<template>
  <form class="searchForm" @submit.prevent="submit">
    <app-form-field title="zoeken" :show-label="false">
      <div class="searchInput">
        <input
          id="search-stock"
          v-model="searchQuery"
          data-qa="search-stock-cars-input"
          type="search"
          title="zoeken"
          :placeholder="searchTextPlaceHolder"
        />
        <app-button data-qa="search-stock-cars-button" class="searchButton" button-type="submit">
          <icon icon="search" />
        </app-button>
      </div>
    </app-form-field>
  </form>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import AppFormField from '@/components/generic/presentational/atoms/formField/FormField.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'

export default {
  components: {
    AppButton,
    Icon,
    AppFormField,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  emits: ['onSearch'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      searchQuery: '',
    }
  },
  computed: {
    searchTextPlaceHolder() {
      return this.i18n.t('/dashboard/quotes/searchText')
    },
  },
  mounted() {
    this.searchQuery = this.modelValue
  },
  methods: {
    submit() {
      this.$emit('onSearch', this.searchQuery)
    },
  },
}
</script>

<style lang="scss" scoped>
.searchForm {
  display: flex;
  flex-flow: row wrap;

  > div {
    width: 100%;
  }
}

.searchInput input {
  width: 21rem;
}

.searchButton {
  border-radius: 0.125em;
}

.searchButton svg {
  width: 1em;
  height: 1em;
}
</style>
